import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const ReportingModulesModelSchema = z
  .object({
    id: z.string(),
    report_id: z.string(),
    module_id: z.string()
  })
  .strict()

const ReportingModulesModelFields = makeFieldKeys(ReportingModulesModelSchema)

type ReportingModulesModel = z.infer<typeof ReportingModulesModelSchema>
